"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const user_statuses_1 = require("@Const/user-statuses");
const react_router_dom_1 = require("react-router-dom");
const GetVerifiedPopup = (props) => {
    const { onCloseConfirmPopup, clickEditProfile, status } = props;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const clickContactSupport = () => {
        navigate('/contact-us');
    };
    return (react_1.default.createElement("div", { className: "main-block" },
        react_1.default.createElement("div", { className: "verified-popup" }, status !== user_statuses_1.USER_VERIFICATION_STATUSES.REJECTED ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h1", null, "You must complete your profile information first."),
            react_1.default.createElement("p", null, "We verify your user information by running it through a 'Know Your Customer (KYC)' check. Please complete your profile information, then try again."),
            react_1.default.createElement("div", { className: 'buttons' },
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: onCloseConfirmPopup }, "Cancel"),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: clickEditProfile }, "Edit My Profile")))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h1", null, "Your account failed 'KYC' verification"),
            react_1.default.createElement("p", null, "We verify your user information by running it through a 'Know Your Customer (KYC)' check. For one reason or another, your verification failed. Please contact support for assistance."),
            react_1.default.createElement("div", { className: 'buttons' },
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: onCloseConfirmPopup }, "Cancel"),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: clickContactSupport }, "Contact Support")))))));
};
exports.default = GetVerifiedPopup;
